import Cookies from 'js-cookie';

export default {
    name: 'CreateBoard',
    data() 
    { 
        return { 
            items: [], 
            points:[], 
            curernt_point:0,
            game_name:"",
            formData: { 
                user: '', 
                point: '' }, 
        }
    },
    methods:{
        saveData() { 
                Cookies.set('pointsJson', JSON.stringify(this.points), { expires: 7 }); 
                Cookies.set('itemsJson', JSON.stringify(this.items), { expires: 7 }); 
                console.log('Data saved to cookie!');
        },
        loadDataCookis() { // Get the JSON data from the cookie and parse it 
            const points1 = Cookies.get('pointsJson'); 
            const items1 = Cookies.get('itemsJson'); 
            console.log(points1);
            console.log(items1);
            if(points1 == null || items1 == null)
            {
                this.loadData();
            }
            else{
                if (Object.keys(points1).length > 0 & Object.keys(items1).length > 0) { 
                    this.points = JSON.parse(points1); 
                    this.items = JSON.parse(items1); 
                    console.log(this.points);
                    console.log(this.items);
                    console.log('Data loaded to cookie!');
                } else { 
                    console.log('Data no loaded to cookie!');
                    this.loadData();
                }
            }
        },
        deleteUserClick(val){
            this.items = this.items.filter(item => item.user_id !== val);
        },
        deletePointClick(val){
            this.points = this.points.filter(point => point.value !== val);
        },
        addUserClick(){
            const newItem = { 
                user_id: this.items.length + 1, 
                user_name: this.formData.user, 
                point: 0, 
                last_point:""
            }; 
            this.items.push(newItem); 
            this.formData.user = "";
        },
        addPointClick(){
            if (typeof Number(this.formData.point) === 'number' && !isNaN(Number(this.formData.point))) {                  
                const newPoint = {
                    value:parseInt(this.formData.point),
                    display:""+this.formData.point+""
                }
                this.points.push(newPoint);
            }
            this.formData.point = "";
        },
        saveToCookies(){
            this.saveData();
            window.location.reload();
        }
    },
    mounted() 
    { 
        this.loadDataCookis(); 
    },

}